import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "../Select";
import useModalStore from "store/modals";
import { useAllPartySupMasts } from "../../../http-hooks/partysupmast/usepartysupmast";

const SelectAgentsAndSalesmen = ({
  value,
  onChange,
  label = "Agent/Salesman",
  placeholder = "Select Agent or Salesman",
  isMulti = false,
  isClearable = true,
  isSearchable = true,
  isDisabled = false,
  isRequired = false,
  className = "",
  filters = {},
  showLabel = true,
  showAddButton = true,
  ...props
}) => {
  const { openModal } = useModalStore();
  
  const { data: agentsAndSalesmen, isLoading } = useAllPartySupMasts({
    type: "A,S",
    level: 0,
    grplevel: 0,
    ag_status: 1,
    noPagination: true,
    ...filters,
  });

  const handleAddNew = () => {
    openModal('vendor', null, { agvct: 'A' }); // Pass type 'A' for Agent (user can change to Salesman in form)
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label} {isRequired && <span className="text-red-500">*</span>}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new agent/salesman"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        options={agentsAndSalesmen?.data || []}
        value={value}
        onChange={onChange}
        getOptionValue={(option) => option?.ps_Id}
        getOptionLabel={(option) => `${option?.name} (${option?.type})`.trim()}
        label={label}
        placeholder={placeholder}
        isMulti={isMulti}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isDisabled={isDisabled}
        isRequired={isRequired}
        isLoading={isLoading}
        className={className}
        showLabel={false}
        {...props}
      />
      {!showLabel && showAddButton && !isDisabled && (
        <button
          type="button"
          onClick={handleAddNew}
          className="absolute top-0 right-0 h-10 w-10 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors duration-200"
          title="Add new agent/salesman"
        >
          <PlusIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SelectAgentsAndSalesmen; 